export const KEY_EVENT_VALUES = {
    BACKSPACE: {
        KEY: 'Backspace',
        CODE: 'Backspace',
        WHICH: 8
    },
    CTRL: {
        KEY: 'Control',
        CODE: 'ControlLeft',
        WHICH: 17
    },
    DELETE: {
        KEY: 'Delete',
        CODE: 'Delete',
        WHICH: 46
    },
    ENTER: {
        KEY: 'Enter',
        CODE: 'Enter',
        WHICH: 13
    },
    LEFT_ARROW: {
        KEY: 'ArrowLeft',
        CODE: 'ArrowLeft',
        WHICH: 37
    },
    RIGHT_ARROW: {
        KEY: 'ArrowRight',
        CODE: 'ArrowRight',
        WHICH: 39
    },
    SHIFT_LEFT: {
        KEY: 'Shift',
        CODE: 'ShiftLeft',
        WHICH: 16
    }
}